/**
 * AMB Pagination Handler
 * Manages the interaction between infinite scroll and pagination
 */

class AmbPagination {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.handleHashScrolling();
      this.manageInfiniteScroll();
      this.enhancePaginationLinks();
    });
  }

  /**
   * Handle URL hash scrolling to specific products
   */
  handleHashScrolling() {
    const url = new URL(window.location.href);
    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    }
  }

  /**
   * Disable infinite scroll when pagination is enabled
   * Check all results-list elements for pagination settings
   */
  manageInfiniteScroll() {
    const resultsLists = document.querySelectorAll('results-list');

    resultsLists.forEach(resultsList => {
      const grid = resultsList.querySelector('[data-pagination-enabled="true"]');

      // @ts-ignore - Custom element property
      if (grid && resultsList.infinityScrollObserver && typeof resultsList.infinityScrollObserver.disconnect === 'function') {
        // Disconnect infinite scroll observer
        // @ts-ignore - Custom element property
        resultsList.infinityScrollObserver.disconnect();

        // Hide view more elements
        const viewMoreElements = resultsList.querySelectorAll('[ref="viewMorePrevious"], [ref="viewMoreNext"]');
        viewMoreElements.forEach(element => {
          if (element && element instanceof HTMLElement) {
            element.style.display = 'none';
          }
        });
      }
    });
  }

  /**
   * Enhance pagination links with smooth transitions
   */
  enhancePaginationLinks() {
    const paginationLinks = document.querySelectorAll('.amb-pagination-link');

    paginationLinks.forEach(link => {
      if (!link.classList.contains('amb-pagination-link--current')) {
        link.addEventListener('click', (e) => {
          // Add loading state
          if (link instanceof HTMLElement) {
            this.addLoadingState(link);
          }
        });
      }
    });
  }

  /**
   * Add loading state to pagination links
   * @param {HTMLElement} link - The clicked pagination link
   */
  addLoadingState(link) {
    const originalText = link.textContent;
    link.style.opacity = '0.6';
    link.style.pointerEvents = 'none';

    // Reset after navigation (fallback)
    setTimeout(() => {
      link.style.opacity = '1';
      link.style.pointerEvents = 'auto';
    }, 2000);
  }

  /**
   * Scroll to product grid when pagination changes
   */
  scrollToProductGrid() {
    const productGrid = document.querySelector('.product-grid');
    if (productGrid) {
      const rect = productGrid.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const targetPosition = rect.top + scrollTop - 100; // 100px offset

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  }
}

// Initialize pagination handler
new AmbPagination();

// Export for potential external use
if (typeof module !== 'undefined' && module.exports) {
  module.exports = AmbPagination;
}
